var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{ref:"tableList",attrs:{"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"loading":_vm.loading,"current-page":_vm.page},on:{"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleClick,"onSearch":_vm.onSearch,"onChange":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }